<script lang="ts">
  import PerPageHead from "../../organisms/settings/PerPageHead.svelte";
</script>

<div class="flex">
  <div class="flex-1 mr-8">
    <PerPageHead />
  </div>
</div>
